import { render, staticRenderFns } from "./schoolContactUs.vue?vue&type=template&id=6487a2fb"
import script from "./schoolContactUs.vue?vue&type=script&lang=js"
export * from "./schoolContactUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports